
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class ListAppCnrtvDialog extends Serenity.EntityDialog<ListAppCnrtvRow, any> {
        protected getFormKey() { return ListAppCnrtvForm.formKey; }
        protected getIdProperty() { return ListAppCnrtvRow.idProperty; }
        protected getLocalTextPrefix() { return ListAppCnrtvRow.localTextPrefix; }
        protected getNameProperty() { return ListAppCnrtvRow.nameProperty; }
        protected getService() { return ListAppCnrtvService.baseUrl; }
        protected getDeletePermission() { return ListAppCnrtvRow.deletePermission; }
        protected getInsertPermission() { return ListAppCnrtvRow.insertPermission; }
        protected getUpdatePermission() { return ListAppCnrtvRow.updatePermission; }

        protected form = new ListAppCnrtvForm(this.idPrefix);

    }
}